import { Link } from "react-router-dom";

const SuccessPage = () => {
  return (
   
      <div className="flex flex-col h-screen justify-center items-center">
        <div className="text-4xl text-green-600 mb-4">✔</div>
        <h2 className="text-xl font-bold mb-2 text-center">Success</h2>
        <p className="text-sm text-gray-600 text-center mb-4">Check your mobile to create a new password</p>
        <p className="text-sm text-gray-600 text-center mb-4">Can't get OTP? <span className="text-primary font-bold">Resubmit</span></p>
        <Link to="/changePassword" className="bg-primary text-white px-6 py-2 rounded-md">Continue</Link>
      </div>
  
  );
};

export default SuccessPage;